import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { LoadingScreen } from '@/components/feedback/loading-screen';
import PermissionGuard from '@/auth/guard/permission-guard';
import { OrionAccess, OrionModule, OrionSubmodule } from '@/types';

const PresalesTicketsListPage = lazy(
  () => import('@pages/management/accounts/presales-tickets/list')
);
const PresalesTicketDetailPage = lazy(
  () => import('@pages/management/accounts/presales-tickets/detail')
);

export const presalesTicketRoutes = [
  {
    path: 'presales-tickets',
    element: (
      <PermissionGuard
        module={OrionModule.ACCOUNT}
        submodule={OrionSubmodule.ACCOUNT.PRESALES_TICKET}
        access={OrionAccess.VIEW}
        hasContent
      >
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </PermissionGuard>
    ),
    children: [
      {
        path: '',
        element: <PresalesTicketsListPage />,
      },
      {
        path: 'list',
        element: <PresalesTicketsListPage />,
      },
      {
        path: ':id',
        element: <PresalesTicketDetailPage />,
      },
    ],
  },
];
